import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "MoreAlternate.svg",
  "use": "MoreAlternate.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"MoreAlternate.svg\"><path d=\"M32.0208,53.0208a5,5,0,1,1,5-5A5,5,0,0,1,32.0208,53.0208Zm0-32a5,5,0,1,1,5-5A5,5,0,0,1,32.0208,21.0209Zm0,16a5,5,0,1,1,5-5A5,5,0,0,1,32.0208,37.0208Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol